let sentryLoaded = false;

export const initSentry = async () => {
  if (sentryLoaded) return;
  sentryLoaded = true;
  const Sentry = await import("@sentry/react");
  Sentry.init({
    dsn: "https://105d732a742dfc2fe440f6b51d0b4102@o4505883423735808.ingest.sentry.io/4505884383969280",
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    ignoreErrors: [
      "This browser doesn't support the API's required to use the Firebase SDK",
      "gtag",
      "network request error",
      "Network request failed",
      "t.toLowerCase is not a function",
      "Failed to execute 'getComputedStyle'",
      "AxiosError",
      "Request failed with status code 400",
    ],
    // Performance Monitoring
    tracesSampleRate: 0.5, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/api\.safetagtracking\.com\//,
    ],
    //Profiling rate
    profilesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};
